import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { KybRunListComponent } from './kyb-run-list/kyb-run-list.component';
import { AmlListComponent } from './aml-list/aml-list.component';
import { APPLICATION_PROCESS_TABS, ApplicationProcessTab, navigationUrlForApplicationProcess } from '../../service/navigation-urls';

/** Tab order; the index is the position in the template's mat-tab-group. */
const TABS = APPLICATION_PROCESS_TABS;

@Component({
  templateUrl: './application-process.page.html',
  styleUrls: ['./application-process.page.scss'],
  standalone: true,
  imports: [MatTabsModule, KybRunListComponent, AmlListComponent],
})
export class ApplicationProcessPage implements OnInit {

  selectedIndex = 0;

  constructor(private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit(): void {
    const innerTab = this.route.snapshot.params['innerTab'] as ApplicationProcessTab | undefined;
    const index = innerTab ? TABS.indexOf(innerTab) : -1;
    this.selectedIndex = index >= 0 ? index : 0;
  }

  onTabChange(event: MatTabChangeEvent): void {
    const tab = TABS[event.index] ?? TABS[0];
    this.router.navigate(navigationUrlForApplicationProcess(tab));
  }
}
